var _path, _rect, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenWsOhm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    fill: "none",
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 90c0-44.183 35.817-80 80-80 44.183 0 80 35.817 80 80 0 44.183-35.817 80-80 80-44.183 0-80-35.817-80-80z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.8,
    y: 54.96,
    width: 70.4,
    height: 70.4,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m82.32 125.36v-13.333c-10.027-3.1562-17.28-12.326-17.28-23.147 0-13.432 11.175-24.32 24.96-24.32 13.785 0 24.96 10.888 24.96 24.32 0 10.821-7.2527 19.991-17.28 23.147l-1e-4 9.798 1e-4 3.375-1e-4.16h27.52v-9.92h-13.59c8.177-6.195 13.43-15.825 13.43-26.64 0-18.689-15.688-33.84-35.04-33.84-19.352 0-35.04 15.151-35.04 33.84 0 10.815 5.2533 20.445 13.43 26.64h-13.59v9.92z",
    clipRule: "evenodd",
    fill: "#708b96",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m90 160c-38.66 0-70-31.34-70-70h-20c0 49.706 40.294 90 90 90zm70-70c0 38.66-31.34 70-70 70v20c49.706 0 90-40.294 90-90zm-70-70c38.66 0 70 31.34 70 70h20c0-49.706-40.294-90-90-90zm0-20c-49.706 0-90 40.294-90 90h20c0-38.66 31.34-70 70-70z",
    fill: "url(#paint0_linear_359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359",
    x1: 80,
    x2: 80,
    y1: -84,
    y2: 256,
    gradientTransform: "translate(10,10)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#708B96",
    offset: 0.19495
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBE7",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWsOhm);
export default __webpack_public_path__ + "static/media/token_wsOHM.12b09bc9.svg";
export { ForwardRef as ReactComponent };